import PropTypes from "prop-types"

import Row from "components/landing/row"
import { jewlr_t } from "helpers/application"
import { getImgSrcSet } from "helpers/image"

export const getDATA = () => ({
  description: {
    desktop: `Add premium gift wrap and a ${jewlr_t("terms.personalized")} card—so your ${jewlr_t("jewelry")} arrives ready to give, no extra work required.`,
    mobile: `Add premium gift wrap and a ${jewlr_t("terms.personalized")} card—so your ${jewlr_t("jewelry")} arrives ready to give, no extra work required.`,
    // desktop: `Every order arrives in our custom packaging. We also offer ${jewlr_t("terms.personalized")} add-ons for the ultimate gifting experience.`,
    // mobile: `Every order arrives in our custom packaging. We also offer ${jewlr_t("terms.personalized")} add-ons for the ultimate gifting experience.`,
    // desktop:
    //   "Transform your gift experience with custom packaging and optional add-ons &ndash; perfect for any occasion.",
    // mobile:
    //   "Transform your gift experience with custom <br />packaging and optional add-ons.",
  },
  image: {
    // To update, go to Strapi > Media Library and upload the images. Then get the urls and replace here.
    // Only replace the folder and the file name and keep the domain ("https://imgsmbly.../cms/") unchanged for auto image optimization.

    desktop: `${sl.config.jewlr_imgsmbly_url}cms/d_valentine_gifting_2026_576c6ad832/d_valentine_gifting_2026_576c6ad832.jpg`,
    desktop_height: 932,
    desktop_width: 1612,
    mobile: `${sl.config.jewlr_imgsmbly_url}cms/m_valentine_gifting_2026_1bc9e44b5d/m_valentine_gifting_2026_1bc9e44b5d.jpg`,
    mobile_height: 400,
    mobile_width: 676,

    // Holiday 2025
    // desktop: `${sl.config.jewlr_imgsmbly_url}cms/d_holiday_gifting_2025_36d1852eb4/d_holiday_gifting_2025_36d1852eb4.jpg`,
    // desktop_height: 1222,
    // desktop_width: 2112,
    // mobile: `${sl.config.jewlr_imgsmbly_url}cms/m_holiday_gifting_2025_d4f59ce0d1/m_holiday_gifting_2025_d4f59ce0d1.jpg`,
    // mobile_height: 400,
    // mobile_width: 676,

    // desktop: `${sl.config.jewlr_imgsmbly_url}cms/d_gift_packaging_b66c586396/d_gift_packaging_b66c586396.jpg`,
    // mobile: `${sl.config.jewlr_imgsmbly_url}cms/m_gift_packaging_2d47ac2f3f/m_gift_packaging_2d47ac2f3f.jpg`,

    // Mothers' day gift packaging
    // desktop: `${sl.config.jewlr_imgsmbly_url}cms/GW_mothers_day_680x450_5a036f10e2/GW_mothers_day_680x450_5a036f10e2.jpg"`,
    // mobile: `${sl.config.jewlr_imgsmbly_url}cms/GW_mothers_day_680x450_5a036f10e2/GW_mothers_day_680x450_5a036f10e2.jpg"`,

    // I LOVE YOU greeting card
    // desktop: `${sl.config.jewlr_imgsmbly_url}cms/packaging_desktop_e040355753/packaging_desktop_e040355753.jpg`,
    // mobile: `${sl.config.jewlr_imgsmbly_url}cms/packaging_mobile_2385ddf7be/packaging_mobile_2385ddf7be.jpg`,

    // Valentine's Day
    // desktop: `${sl.config.jewlr_imgsmbly_url}cms/d_valentines_gift_wrap_68c0e6ee03/d_valentines_gift_wrap_68c0e6ee03.jpg`,
    // mobile: `${sl.config.jewlr_imgsmbly_url}cms/m_valentines_gift_wrap_879334d588/m_valentines_gift_wrap_879334d588.jpg`,
  },
  link: "/info/packaging",
  title: "Perfectly Wrapped. Ready to Gift.",
  // title: "Packaged For Gifting",
  // title: "Easy Gifting… That’s a Wrap",
})

const LandingPackaging = ({ element, lazyload }) => {
  const DATA = getDATA()

  const data = {
    ...element,
    columns: [
      {
        column_style: {
          flex: { _: 1, desktop: "1 1 40%" },
          ml: { desktop: 5, tablet: 2 },
        },
        components: [
          {
            textarea: {
              style: {
                maxWidth: { tablet: "684px" },
                textAlign: { _: "center", tablet: "left" },
              },
              texts: [
                {
                  style: { mb: { _: 1, tablet: 2 } },
                  text: DATA.title,
                  type: "homepage_heading",
                },
                {
                  style: {
                    display: { tablet: "none" },
                    px: { _: 2 },
                  },
                  text: DATA.description.mobile,
                  type: "homepage_description",
                },
                {
                  style: {
                    display: { _: "none", tablet: "block" },
                    width: { desktop: "428px" },
                  },
                  text: DATA.description.desktop,
                  type: "homepage_description",
                },
                {
                  base_style: "underline",
                  style: {
                    display: "inline-block",
                    fontSize: { _: "15px", tablet: "17px", widescreen: "19px" },
                    fontWeight: { _: "500", widescreen: "400" },
                    letterSpacing: "0.5px",
                    mt: { _: 3, desktop: 4 },
                  },
                  text: "Learn More",
                  type: "link",
                  url: DATA.link,
                },
              ],
            },
          },
        ],
      },
      {
        column_style: {
          flex: { _: 1, desktop: "1 1 60%" },
          order: { tablet: -1 },
        },
        components: [
          {
            image: {
              alt: DATA.title,
              fallback: DATA.image.desktop,
              srcSet: [
                {
                  height: DATA.image.mobile_height,
                  media: "(max-width: 767px)",
                  sizes: "100vw",
                  srcSet: getImgSrcSet(
                    DATA.image.mobile,
                    DATA.image.mobile_width
                  ),
                  width: DATA.image.mobile_width,
                },
                {
                  height: DATA.image.desktop_height,
                  media: "(min-width: 768px)",
                  sizes: "(max-width: 1920px) 50vw, 1056px",
                  srcSet: getImgSrcSet(
                    DATA.image.desktop,
                    DATA.image.desktop_width
                  ),
                  width: DATA.image.desktop_width,
                },
              ],
              url: DATA.link,
            },
          },
        ],
      },
    ],
    style: {
      alignItems: "center",
      container_style: {
        containWide: true,
        px: { _: 2, tablet: 4, widescreen: "60px" },
        py: { _: 4, widescreen: "60px" },
        ...element.style,
      },
      flexDirection: { _: "column", tablet: "row" },
      flexWrap: "nowrap",
      justifyContent: "center",
      ...element.container_style,
    },
  }

  return <Row element={data} lazyload={lazyload} />
}

LandingPackaging.propTypes = {
  element: PropTypes.object,
  lazyload: PropTypes.bool,
}

export default LandingPackaging
